import { XMarkIcon } from '@heroicons/react/24/solid'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const SelectBar = ({ table, withActions }) => {
  const { t } = useTranslation()

  const number_selected = table.getSelectedRowModel().rows.length

  if (!withActions) return null
  if (number_selected === 0) return null

  return (
    <>
      <div
        id='select-bar'
        className='flex h-14 w-full flex-row items-center justify-between bg-blue-600 px-4 sm:px-6 lg:px-8'
      >
        <span className='text-sm font-medium text-white'>
          {number_selected === 1
            ? t('react_table.select_bar.one_selected')
            : t('react_table.select_bar.number_selected', {
                number: number_selected
              })}
        </span>
        <div className='flex flex-row items-center'>
          {withActions}
          {/* <div className='mx-2 h-6 w-px bg-white'></div> */}
          <button
            className='flex h-8 w-8 cursor-pointer items-center justify-center rounded-full hover:bg-blue-700'
            onClick={() => table.resetRowSelection(true)}
          >
            <XMarkIcon className='h-6 w-6 text-white' />
          </button>
        </div>
      </div>
      <div className='relative left-8 h-0 w-0 rotate-180 border-x-8 border-b-[10px] border-x-transparent border-b-blue-600' />
    </>
  )
}

SelectBar.propTypes = {
  table: PropTypes.object.isRequired,
  withActions: PropTypes.node
}

SelectBar.defaultProps = {
  withActions: undefined
}

export default SelectBar
